function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}
module.exports = _isString;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/html-to-react/~/ramda/src/internal/_isString.js
// module id = 896
// module chunks = 4